(function () {
  const FORM_SELECTOR = '#ContactForm';

  function getMessages(form) {
    const root = form.closest('.form-contact__form');

    return {
      required:
        root?.dataset.errorRequired || 'This field is required.',
      emailInvalid:
        root?.dataset.errorEmail || 'Please enter a valid email address.',
      phoneInvalid:
        root?.dataset.errorPhone || 'Please enter a valid phone number.',
    };
  }

  function getFieldError(field) {
    return field
      .closest('custom-input-wrapper')
      ?.querySelector('[data-field-error]');
  }

  function showFieldError(field, message) {
    const errorEl = getFieldError(field);
    const errorText = errorEl?.querySelector('[data-field-error-text]');

    field.classList.add('input--error');
    field.setAttribute('aria-invalid', 'true');

    if (errorEl) {
      if (errorText) {
        errorText.textContent = message;
      } else {
        errorEl.textContent = message;
      }

      errorEl.hidden = false;
      field.setAttribute('aria-describedby', errorEl.id);
    }
  }

  function clearFieldError(field) {
    const errorEl = getFieldError(field);

    field.classList.remove('input--error');
    field.removeAttribute('aria-invalid');

    if (errorEl) {
      errorEl.hidden = true;
      field.removeAttribute('aria-describedby');
    }
  }

  function validateField(field, messages, showErrors) {
    const value = field.value.trim();

    if (!value) {
      if (showErrors) showFieldError(field, messages.required);
      return false;
    }

    if (field.type === 'email' && !field.checkValidity()) {
      if (showErrors) showFieldError(field, messages.emailInvalid);
      return false;
    }

    if (field.type === 'tel' && !field.checkValidity()) {
      if (showErrors) showFieldError(field, messages.phoneInvalid);
      return false;
    }

    if (showErrors) clearFieldError(field);
    return true;
  }

  function isFormComplete(fields, messages) {
    return [...fields].every((field) => validateField(field, messages, false));
  }

  function init() {
    const form = document.querySelector(FORM_SELECTOR);
    if (!form || form.dataset.validationEnhanced === 'true') return;

    form.dataset.validationEnhanced = 'true';

    const messages = getMessages(form);
    const fields = form.querySelectorAll('input[required], textarea[required]');
    const submitBtn = form.querySelector('[type="submit"]');

    if (!fields.length || !submitBtn) return;

    const updateSubmitButton = () => {
      submitBtn.disabled = !isFormComplete(fields, messages);
    };

    fields.forEach((field) => {
      field.addEventListener('input', () => {
        if (field.classList.contains('input--error')) {
          validateField(field, messages, true);
        }
        updateSubmitButton();
      });

      field.addEventListener('blur', () => {
        if (field.classList.contains('input--error')) {
          validateField(field, messages, true);
        }
        updateSubmitButton();
      });
    });

    form.addEventListener('submit', (event) => {
      let isValid = true;

      fields.forEach((field) => {
        if (!validateField(field, messages, true)) {
          isValid = false;
        }
      });

      if (!isValid) {
        event.preventDefault();
        form.querySelector('.input--error')?.focus();
      }
    });

    updateSubmitButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
